// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","content":"qr-code_content__sIRSV","qr":"qr-code_qr__Wy9+F","share":"qr-code_share__5vPfv","icons":"qr-code_icons__ITu8+"};